export default __webpack_public_path__ + "static/media/hard.4c1596e1.png";